import React, {memo, useEffect, useState} from 'react';
import {View, Text, StyleProp, TextStyle} from 'react-native';

import { StyleSheet } from 'react-native';
import {colorPalette} from '../../../core/config/color.config';

import {RNEText} from '../../components';

import {formatToMessageTime} from '../../utils/date.utils';
import { width, height, totalSize } from 'react-native-dimension';

interface ConsultationDeclinedMessageProps {
  recommendationType: string;
  recommendationValue: string;
  recommendationDoctorDetails: any;
  timestamp: Date;
  owner?: boolean;
}

const ConsultationDeclinedMessage = (props: ConsultationDeclinedMessageProps) => {

  // console.log(props.recommendationDoctorDetails,'recommendationDoctorDetails')
  // console.log(props.recommendationType,'recommendationType')
  // console.log(props.recommendationValue,'recommendationValue');

  const [dynamicTxt, setDynamicTxt] = useState("");

  useEffect(()=>{
    if(props.recommendationType === 'other'){
      var txt = props.recommendationValue;
      setDynamicTxt(txt);
    }else{

      // Extract names
    const firstName = props?.recommendationDoctorDetails?.humanName?.given?.[0] ?? "";
    const middleName = props?.recommendationDoctorDetails?.humanName?.given?.[1] ?? "";
    const lastName = props?.recommendationDoctorDetails?.humanName?.family ?? "";

    // Build full name (exclude middle name if empty)
    const doctorName = middleName
    ? `${firstName} ${middleName} ${lastName}`
    : `${firstName} ${lastName}`;

    var txt = 'You can try contacting '+doctorName+' for this consultation.';

      setDynamicTxt(txt);
    }
  },[props.recommendationType])
  
  return (
    <View>
      <View style={styles.timestamp}>
        <RNEText
          label={formatToMessageTime(props.timestamp)}
          color="grey"
          variant="button"
          weight="600"
        />
      </View>
      <View
        style={[
          styles.messageContainer,
          // eslint-disable-next-line react-native/no-inline-styles
          {
            alignItems: props.owner ? 'flex-end' : 'flex-start',
          },
        ]}>
        <View
          style={[
            styles.messageWrapper,
            // eslint-disable-next-line react-native/no-inline-styles
            {
              borderTopRightRadius: props.owner ? 0 : 12,
              borderTopLeftRadius: props.owner ? 12 : 0,
            },
          ]}>
        
          {/* <RNEText label={props.message} color="white" variant="button" /> */}
          <RNEText label={'Hello!'} color="white" variant="button" />

          <RNEText label={'I’m sorry, but I can’t cater to your appointment request today.'} color="white" variant="button" />

          <View style={{marginTop: height(1.5),marginBottom: height(1.5)}}>
            <RNEText label={dynamicTxt} color="white" variant="button" />
          </View>

          <RNEText label={'Thanks for your consideration.'} color="white" variant="button" />
          
          <RNEText label={'Stay safe!'} color="white" variant="button" />
          {/* <RNEText label={messageTxt} color="white" variant="button" /> */}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  timestamp: {
    alignItems: 'center',
    marginTop: height(1),
  },
  messageContainer: {
    marginTop: height(1.5),
  },
  messageWrapper: {
    width: '60%',
    backgroundColor: colorPalette.purple,
    padding: height(2),
    paddingLeft: width(6),
    paddingRight: width(6),
    borderRadius: totalSize(2),
  },
}); 

export default memo(ConsultationDeclinedMessage);
